<div class="valueBadges" role="group" aria-label="Штрих-коды">
  <div class="barcodeBadgeGroup" *ngFor="let barcode of barcodes">
    <span class="valueBadge" [class.valueBadgeShared]="barcode.shared_products?.length">
      <span class="valueBadgeText">{{ barcode.barcode }}</span>
      <button
        type="button"
        class="valueBadgeRemove"
        [attr.aria-label]="'Удалить штрих-код ' + barcode.barcode"
        matTooltip="Удалить штрих-код"
        (click)="deleteBarcode(barcode.barcode)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </span>
    <div class="sharedBarcode" *ngIf="barcode.shared_products?.length">
      <mat-icon>warning_amber</mat-icon>
      Общий штрихкод:
      <span *ngFor="let product of barcode.shared_products; let last = last">
        {{ product.brand }} {{ product.article }}<ng-container *ngIf="!last">,</ng-container>
      </span>
    </div>
  </div>
  <button
    type="button"
    class="valueBadgeAdd"
    aria-label="Добавить штрих-код"
    (click)="openBarcodeDialog()"
  >
    <mat-icon>add</mat-icon>Добавить
  </button>
</div>
